<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ahSwi9/tc-custom/9780814763865.jpg?1728259339748" alt="This image is the cover for the book Sephardic and Mizrahi Jewry"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sephardic and Mizrahi Jewry
      </h1>
      <p class="bookDescription body article font2">
        <p>Sephardic Jews trace their origins to Spain and Portugal. They enjoyed a renaissance in these lands until their expulsion from Spain in 1492, when they settled in the countries along the Mediterranean, throughout the Ottoman Empire, in the Balkans, and in the lands of North Africa, Italy, Egypt, Palestine, and Syria, mixing with the Mizrahi, or Oriental, Jews already in these locations. Sephardic Jews have contributed some of the most important Jewish philosophers, poets, biblical commentators, Talmudic and Halachic scholars, and scientists, and have had a significant impact on the development of Jewish mysticism.<br/><b>Sephardic and Mizrahi Jewry</b> brings together original work from the world's leading scholars to present a deep introductory overview of their history and culture over the past 1500 years. The book presents an overarching chronological and thematic survey of topics ranging from the origin of Sephardic and Mizrahi Jewry and their history to kabbalah, philosophy, and biblical commentary, and Sephardic Jewish life in the modern era. This collection represents the most up-to-date scholarship about Sephardic and Mizrahi Jewry available.<br/><b>Contributors include:</b> Mark R. Cohen, Norman Stillman, David Bunis, Jonathan Decter, Yitzhak Kalimi, Moshe Idel, Annette B. Fromm, Zvi Zohar, Morris Fairstein, Pamela Dorn Sezgin, Mark Kligman, and Henry Abramson.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zion Zohar
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2a165ead